import type * as React from 'react';

export function CustomBlockquoteIcon({
    size = 16,
    color = 'currentColor',
    strokeWidth = 1.33,
    fill = 'none',
    ...props
}: React.SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill={fill}
            {...props}
        >
            <path
                d="M5 12.4997H17.5M17.5 15.833H5M12.5 9.16634H17.5M17.5 5.83301H12.5M7.5 7.49967H8.33333C8.49815 7.49967 8.65927 7.54855 8.79631 7.64012C8.93335 7.73168 9.04016 7.86183 9.10323 8.0141C9.16631 8.16638 9.18281 8.33393 9.15065 8.49558C9.1185 8.65723 9.03913 8.80572 8.92259 8.92226C8.80604 9.03881 8.65756 9.11817 8.49591 9.15033C8.33426 9.18248 8.1667 9.16598 8.01443 9.10291C7.86216 9.03983 7.73201 8.93302 7.64044 8.79598C7.54887 8.65894 7.5 8.49783 7.5 8.33301V6.24967C7.5 5.80765 7.67559 5.38372 7.98816 5.07116C8.30072 4.7586 8.72464 4.58301 9.16667 4.58301M2.5 7.49967H3.33333C3.49815 7.49967 3.65927 7.54855 3.79631 7.64012C3.93335 7.73168 4.04016 7.86183 4.10323 8.0141C4.16631 8.16638 4.18281 8.33393 4.15065 8.49558C4.1185 8.65723 4.03913 8.80572 3.92259 8.92226C3.80605 9.03881 3.65756 9.11817 3.49591 9.15033C3.33426 9.18248 3.1667 9.16598 3.01443 9.10291C2.86216 9.03983 2.73201 8.93302 2.64044 8.79598C2.54887 8.65894 2.5 8.49783 2.5 8.33301V6.24967C2.5 5.80765 2.67559 5.38372 2.98816 5.07116C3.30072 4.7586 3.72464 4.58301 4.16667 4.58301"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
